import http from "helpers/http/http.helper";
import { buildAuditLogsApiParams } from "helpers/audit-log/build-audit-logs-params.helper";

export const AUDIT_LOGS_LOADING = "AUDIT_LOGS_LOADING";
export const GET_AUDIT_LOGS = "GET_AUDIT_LOGS";
export const AUDIT_LOGS_ERRORS = "AUDIT_LOGS_ERRORS";
export const EXPORT_AUDIT_LOGS_LOADING = "EXPORT_AUDIT_LOGS_LOADING";
export const EXPORT_AUDIT_LOGS = "EXPORT_AUDIT_LOGS";
export const EXPORT_AUDIT_LOGS_ERRORS = "EXPORT_AUDIT_LOGS_ERRORS";

export const getAuditLogs = params => async dispatch => {
  try {
    dispatch({
      type: AUDIT_LOGS_LOADING,
      payload: true
    });
    const response = await http().get("/audit-logs", { params });
    dispatch({
      type: GET_AUDIT_LOGS,
      payload: response.data
    });
  } catch (error) {
    if (error?.response?.status === 401) {
      return (window.location.href = "/");
    }
    dispatch({
      type: AUDIT_LOGS_ERRORS,
      payload: error?.response?.data?.errors || error
    });
  } finally {
    dispatch({
      type: AUDIT_LOGS_LOADING,
      payload: false
    });
  }
};

export const exportAuditLogs = (params, format = "xlsx") => async dispatch => {
  try {
    dispatch({
      type: EXPORT_AUDIT_LOGS_LOADING,
      payload: true
    });
    const queryParams = buildAuditLogsApiParams({ ...params, format });
    delete queryParams.page;
    delete queryParams.limit;
    const response = await http().get("/audit-logs/export", {
      params: queryParams,
      responseType: "blob"
    });
    dispatch({
      type: EXPORT_AUDIT_LOGS,
      payload: { response, format }
    });
  } catch (error) {
    if (error?.response?.status === 401) {
      return (window.location.href = "/");
    }
    dispatch({
      type: EXPORT_AUDIT_LOGS_ERRORS,
      payload: error?.response?.data?.errors || error
    });
  } finally {
    dispatch({
      type: EXPORT_AUDIT_LOGS_LOADING,
      payload: false
    });
  }
};
